<template>
  <div class="wrapper">
    <Tabs @on-click="tabChange" :value="labelMsgq">
      <TabPane label="每日一练" name="currents">
        <currentt :reSearch="reSearch" ref="currentt" />
      </TabPane>
      <TabPane label="练习记录" name="lists">
        <list ref="list" />
      </TabPane>
    </Tabs>
  </div>
</template>
<script>
  import currentt from "./currentt"
  import list from "./list"
  export default {
    components: { currentt, list },
    data() {
      return {
        newdate: new Date().Format('yyyy-MM-dd hh:mm:ss'),
        labelMsgq: "currents",
        reSearch: {
          type: 4,
          days: '',
        },
      }
    },
    activated() { },
    methods: {
      tabChange(name) {
        this.labelMsgq = name
      },
    },
  }
</script>
<style scoped lang="less">
  .wrapper {
    width: 100%;
    padding: 0 10px;
  }
</style>
